import React, { Component } from 'react';
import _ from 'lodash';
import MD from 'react-markdown';
import Team from './Info/Team';
import Contact from './Info/Contact';
import Copyright from './All/Copyright';
import Imagelist from './other/Imagelist';
import logo from '../assets/AHTT_logo.gif';

class Info extends Component {
    render() {
        console.log(this.props);
        const { description, images } = this.props.content;

        let imageUrls = images.map((o)=>{
            const url = o.imgType === "gif" ? o.url : o.url + "&w=500";
            return url;
        });
        // can also do splice(1,0) - e.g. make map second item
        imageUrls.push("https://www.google.com/maps/embed/v1/place?key=AIzaSyCw8P66llXMC0hlnZ25awLf92_3oUXbgYI&q=Anyways+Here's+the+Thing+NY");

        return (
            <div className="content" id="info-page">
                <div className="description">
                    <MD source={description}/>
                    <img src={logo} className="logo" alt="logo" /><br/>
                    <Imagelist list={imageUrls} />
                </div>
                <Team members={_.sortBy(this.props.members, "index")}/>
                <Contact />
                <Copyright />
            </div>

        );
    }
}

export default Info;



// WEBPACK FOOTER //
// ./src/components/Info.js